(() => {
  'use strict';

  const allowedTopics = new Set([
    'guest-order', 'order-status', 'delivery', 'return',
    'cancellation', 'warranty', 'fitment', 'other'
  ]);
  const topic = new URLSearchParams(window.location.search).get('topic');
  if (!allowedTopics.has(topic)) return;

  // Back/forward and reload can restore an intentional selection, including blank.
  const navigation = window.performance?.getEntriesByType?.('navigation')[0];
  if (navigation && navigation.type !== 'navigate') return;

  document.querySelectorAll('[data-rr-contact-topic]').forEach((select) => {
    if (select.dataset.topicInitialized === 'true') return;
    select.dataset.topicInitialized = 'true';
    if (select.dataset.formRestored === 'true' || select.value !== '') return;
    if (!Array.from(select.options).some((option) => option.value === topic)) return;
    select.value = topic;
  });
})();
